import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from '../../firebase/Firebase'
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getDoc, doc } from "firebase/firestore";
import { setFirstName, setOrganization, setOrganizationId } from "../../redux/Redux";
import AppStore from '../../assets/appstore.png'
import PlayStore from '../../assets/playstore.png'

const appStoreListing = 'https://apps.apple.com/us/app/vasco-delivery-tracker/id6451427842'
const playStoreListing = 'https://play.google.com/store/apps/details?id=com.nedweingart.vasco'

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchUserOrganizationAndName = async (uid) => {
    const userRef = doc(db, 'Users', uid);
    const userSnapshot = await getDoc(userRef);

    if (userSnapshot.exists()) {
      const userData = userSnapshot.data();
      const orgRef = doc(db, 'Organizations', userData.orgId);
      const orgSnapshot = await getDoc(orgRef);

      if (orgSnapshot.exists()) {
        const orgData = orgSnapshot.data();
        console.log(orgData);

        dispatch(setFirstName(userData.firstName));
        localStorage.setItem("orgId", userData.orgId);

        console.log(userData.orgId);

        navigate("/dashboard");
        return;
      }
    }
    console.error(`No user found with UID: ${uid}`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await fetchUserOrganizationAndName(user.uid);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={styles.container}>
      <img src="/appicon.png" alt="App Logo" style={styles.logo} />
      <h2 style={styles.header}>Login</h2>
      {error && <p style={styles.error}>{error}</p>}
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />
        <button type="submit" style={styles.button}>Login</button>
      </form>
      <div style={styles.promotionalText}>New to Vasco? Download the app below.</div>
      <div style={styles.storeLinks}>
        <a href={appStoreListing} target="_blank" rel="noopener noreferrer">
          <img src={AppStore} alt="Download on the App Store" style={styles.storeImage} />
        </a>
        <a href={playStoreListing} target="_blank" rel="noopener noreferrer">
          <img src={PlayStore} alt="Get it on Google Play" style={styles.storeImage} />
        </a>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    padding: '50px',
    borderRadius: '10px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    width: '400px',
    margin: 'auto',
    marginTop: '100px'
  },
  header: {
    color: '#000000'
  },
  error: {
    color: '#FF0000',
    marginBottom: '15px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  input: {
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    backgroundColor: '#FFC300',
    color: '#000000',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: '0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#E5B100'
    }
  },
  link: {
    color: '#000000',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none'
    }
  },
  logo: {
    width: '100px',
    marginBottom: '20px',
  },
  promotionalText: {
    marginTop: 25,
    fontWeight: 600
  },
  storeLinks: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '10px',
    width: '100%'
  },
  storeImage: {
    width: '150px',
    height: 'auto',
    margin: '0 10px',
  },
}

export default Login;

